// Web Push subscription helper for SoumissionPro
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export function isPushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export async function getPushPermission() {
  if (!isPushSupported()) return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

export async function subscribeUserToPush(userId) {
  if (!isPushSupported() || !VAPID_PUBLIC_KEY || !userId) return null;

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return { status: permission };

    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
    }

    const json = sub.toJSON();
    await axios.post(`${API}/push/subscribe`, {
      endpoint: json.endpoint,
      keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
      user_id: userId,
      user_agent: navigator.userAgent || '',
    });
    return { status: 'subscribed' };
  } catch (err) {
    console.warn('push subscribe failed', err);
    return { status: 'error', error: err };
  }
}

export async function unsubscribeFromPush() {
  if (!isPushSupported()) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      const endpoint = sub.endpoint;
      await sub.unsubscribe();
      try {
        await axios.post(`${API}/push/unsubscribe`, { endpoint });
      } catch (e) { console.warn('[push] unsubscribe POST failed:', e); }
    }
  } catch (err) {
    console.warn('push unsubscribe failed', err);
  }
}

export async function notifySigned({ submission_id, user_id, submission_number, client_name, signed_by_name }) {
  try {
    await axios.post(`${API}/push/notify-signed`, {
      submission_id,
      user_id,
      submission_number: submission_number || '',
      client_name: client_name || '',
      signed_by_name: signed_by_name || '',
    });
  } catch (err) {
    // Best-effort; don't block the signing flow
    console.warn('notify-signed failed', err);
  }
}

export async function notifyRefused({ submission_id, user_id, submission_number, client_name, refused_by_name, refusal_reason }) {
  try {
    await axios.post(`${API}/push/notify-refused`, {
      submission_id,
      user_id,
      submission_number: submission_number || '',
      client_name: client_name || '',
      refused_by_name: refused_by_name || '',
      refusal_reason: refusal_reason || '',
    });
  } catch (err) {
    // Best-effort; never block the refuse flow
    console.warn('notify-refused failed', err);
  }
}
